import React, { useState } from 'react';
import PageHero from '../components/PageHero';
import { company, whatsappLink } from '../data/site';
import './pages.css';

const emptyForm = {
    name: '',
    email: '',
    phone: '',
    organization: '',
    subject: '',
    message: '',
};

const Contact: React.FC = () => {
    const [form, setForm] = useState(emptyForm);
    const [sent, setSent] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const url = whatsappLink('Kifayti — Website Enquiry', {
            Name: form.name,
            Email: form.email,
            Phone: form.phone,
            Organization: form.organization,
            Subject: form.subject,
            Message: form.message,
        });

        window.open(url, '_blank', 'noopener,noreferrer');
        setForm(emptyForm);
        setSent(true);
        window.setTimeout(() => setSent(false), 6000);
    };

    return (
        <>
            <PageHero
                kicker="Contact"
                title={
                    <>
                        Let&apos;s talk about <span className="grad-text">your operations</span>
                    </>
                }
                description="Product demos, custom development, franchise enquiries or support — reach the team directly. We reply fastest on WhatsApp."
            />

            <section className="section section--light">
                <div className="container form-layout">
                    <div className="form-layout__intro" data-reveal="left">
                        <span className="kicker">Reach us</span>
                        <h2>Direct lines</h2>

                        <ul className="contact-list">
                            <li className="enter" style={{ ['--i' as string]: 2 }}>
                                <span className="contact-list__icon" aria-hidden="true">
                                    ✉️
                                </span>
                                <div>
                                    <h4>Email</h4>
                                    <a href={`mailto:${company.email}`}>{company.email}</a>
                                </div>
                            </li>
                            <li className="enter" style={{ ['--i' as string]: 3 }}>
                                <span className="contact-list__icon" aria-hidden="true">
                                    📞
                                </span>
                                <div>
                                    <h4>Phone</h4>
                                    <a href={`tel:+${company.phoneRaw}`}>{company.phone}</a>
                                </div>
                            </li>
                            <li className="enter" style={{ ['--i' as string]: 4 }}>
                                <span className="contact-list__icon" aria-hidden="true">
                                    💬
                                </span>
                                <div>
                                    <h4>WhatsApp</h4>
                                    <a
                                        href={company.social.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Message us directly
                                    </a>
                                </div>
                            </li>
                            <li className="enter" style={{ ['--i' as string]: 5 }}>
                                <span className="contact-list__icon" aria-hidden="true">
                                    🏢
                                </span>
                                <div>
                                    <h4>Registered office</h4>
                                    <p>
                                        {company.address.line1}
                                        <br />
                                        {company.address.line2}
                                    </p>
                                </div>
                            </li>
                            <li className="enter" style={{ ['--i' as string]: 6 }}>
                                <span className="contact-list__icon" aria-hidden="true">
                                    🕒
                                </span>
                                <div>
                                    <h4>Business hours</h4>
                                    <p>
                                        Monday – Saturday: 9:00 AM – 7:00 PM
                                        <br />
                                        Sunday: closed for support enquiries
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="form-card" data-reveal="right">
                        {sent && (
                            <p className="form-success" role="status">
                                Thanks — WhatsApp has opened with your message. Send it there and we
                                will get back to you shortly.
                            </p>
                        )}

                        <form onSubmit={handleSubmit} className="form-stack">
                            <div className="field-row">
                                <div className="field">
                                    <label htmlFor="c-name">Name *</label>
                                    <input
                                        id="c-name"
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="field">
                                    <label htmlFor="c-email">Email *</label>
                                    <input
                                        id="c-email"
                                        name="email"
                                        type="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="field-row">
                                <div className="field">
                                    <label htmlFor="c-phone">Phone</label>
                                    <input
                                        id="c-phone"
                                        name="phone"
                                        type="tel"
                                        value={form.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="field">
                                    <label htmlFor="c-org">School / organization</label>
                                    <input
                                        id="c-org"
                                        name="organization"
                                        value={form.organization}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label htmlFor="c-subject">What is this about? *</label>
                                <select
                                    id="c-subject"
                                    name="subject"
                                    value={form.subject}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a subject</option>
                                    <option>Product demo — Feeisy (School ERP)</option>
                                    <option>Product demo — PAGARisy (Payroll &amp; HRMS)</option>
                                    <option>Product demo — Promoisy (Digital signage)</option>
                                    <option>Product demo — QUOTATIONisy (Quotations)</option>
                                    <option>Product demo — Fixisy (Repair management)</option>
                                    <option>Custom software development</option>
                                    <option>School / organization digitalization</option>
                                    <option>Franchise opportunity</option>
                                    <option>Partnership</option>
                                    <option>Support</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div className="field">
                                <label htmlFor="c-message">Message *</label>
                                <textarea
                                    id="c-message"
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    required
                                    placeholder="Tell us how you operate today and what you are trying to fix…"
                                />
                            </div>

                            <button type="submit" className="btn btn--primary btn--lg">
                                Send via WhatsApp
                            </button>
                            <p className="form-note">
                                Submitting opens WhatsApp with your details pre-filled. Nothing is
                                sent until you press send there.
                            </p>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;
